<script lang="ts">
  export let as = 'p';
  export let text: string;
  let className: string | undefined = undefined;
  export { className as class };
</script>

<div class={className}>
  {#each text.split('\n') as line}
    {#if !line}
      <br />
    {:else}
      <svelte:element this={as}>{line}</svelte:element>
    {/if}
  {/each}
</div>
